// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-app>
    <v-navigation-drawer app clipped :temporary="false" v-model="showDrawer">
      <v-list style="padding: 0px;">
        <v-list-tile v-if="isMobile" style="background-color: rgba(0,0,0,0.07);">
          <v-list-tile-action >
            <v-menu offset-y>
              <v-btn icon flat slot="activator"><v-icon x-large>account_circle</v-icon></v-btn>
              <v-list>
                <v-list-tile :to="{name: 'userMe'}">
                  <v-list-tile-title>Profile</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logout">
                  <v-list-tile-title>Logout</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>

        <template v-for="(item, i) in menu">
          <template v-if="item.items">
            <v-list-group :key="i">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-for="subItem in item.items" :key="subItem.title" :to="{name: subItem.route}">
                <v-list-tile-action> </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-tile :to="{name: item.route}" :key="i">
              <v-list-tile-action>
                <v-icon>{{ item.action }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </template>
        <v-list-tile style="background-color: rgba(0,0,0,0.07);">
          <v-list-tile-action>
            <v-icon></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>v{{ version }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app clipped-left clipped-right fixed>
      <v-toolbar-side-icon @click.stop="showDrawer = !showDrawer"></v-toolbar-side-icon>
      <v-toolbar-title>Blue Conductor</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y v-if="!isMobile">
        <v-btn icon flat slot="activator"><v-icon x-large>account_circle</v-icon></v-btn>
        <v-list>
          <v-list-tile :to="{name: 'userMe'}">
            <v-list-tile-title>Profile</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer style="height: 82px; background-color: #fafafa;">
    </v-footer>

  </v-app>
</template>

<script>
import { removeCookie } from 'tiny-cookie'
import { mapActions, mapGetters } from 'vuex'
import {PERMISSIONS} from 'vue-common/components/constants'
import {AXIOSAPI} from 'vue-common/components/requests-common'
import {checkPermission} from 'vue-common/components/user'
import {version} from '../../package.json'

export default {

  data () {
    return {
      showDrawer: true,
      version: version
    }
  },

  created () {
    this.getUserData()
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    adminMenu: function () {
      var adminMenuList = []

      if (checkPermission(this.accessRules, 'users', PERMISSIONS.CREATE)) {
        adminMenuList.push({
          title: 'Users',
          route: 'users',
          action: 'group'
        })
      }

      return {
        action: 'build',
        title: 'Admin',
        items: adminMenuList
      }
    },

    configurationMenu: function () {
      var configurationMenuList = []

      if (checkPermission(this.accessRules, 'apikeys', PERMISSIONS.CREATE)) {
        configurationMenuList.push({
          title: 'API Keys',
          route: 'apikeys',
          action: 'vpn_key'
        })
      }

      if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
        configurationMenuList.push({
          title: 'Organizations',
          route: 'organizations',
          action: 'filter_list'
        })
      }
      return {
        action: 'settings',
        title: 'Configuration',
        items: configurationMenuList
      }
    },

    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly
    },

    menu: function () {
      var menu = []

      menu.push({
        action: 'home',
        title: 'Home',
        route: 'home'
      },
      {
        action: 'devices',
        title: 'Devices',
        route: 'devices'
      })
      // {
      //   action: 'waves',
      //   title: 'QR Code Generator',
      //   route: 'qrcode'
      // })

      if (this.adminMenu.items.length > 0) {
        menu.push(this.adminMenu)
      }

      if (this.configurationMenu.items.length > 0) {
        menu.push(this.configurationMenu)
      }

      return menu
    }
  },

  methods: {
    ...mapActions([
      'getUserData'
    ]),

    logout: function () {
      var parent = '.' + window.location.hostname.split('.').slice(-2).join('.')
      console.log(parent)
      AXIOSAPI.post('auth/logout').then(response => {
        removeCookie('token', {domain: parent})
      }).catch(e => {
        console.error(e)
        // This appears twice and in the request repsonse so that there is no race condition
        // between deleting the cookie and sending the request that requires it
        removeCookie('token', {domain: parent})
      })
      this.$router.push({name: 'login'})
    }
  }
}
</script>

<style>
.container {
  padding-bottom: 8px;
  padding-top: 8px;
  padding-left: 8px;
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue